export default () => {
  const countdowns = document.querySelectorAll('[data-countdown]');
  [].forEach.call(countdowns, (countdown) => {
    const targetDate = Date.parse(countdown.getAttribute('data-countdown'));
    let days;
    let hours;
    let minutes;
    let seconds;
    let interval;
    const pad = (n) => (n < 10 ? '0' : '') + n;

    const getCountdown = () => {
      const currentDate = new Date().getTime();
      let secondsLeft = (targetDate - currentDate) / 1000;
      const secondsNode = countdown.querySelector('[data-times="s"]');
      if (secondsLeft < 0) {
        clearInterval(interval);
        return;
      }
      days = pad(parseInt(secondsLeft / 86400, 10));
      secondsLeft %= 86400;
      hours = pad(parseInt(secondsLeft / 3600, 10));
      secondsLeft %= 3600;
      minutes = pad(parseInt(secondsLeft / 60, 10));
      seconds = pad(parseInt(secondsLeft % 60, 10));
      countdown.querySelector('[data-times="d"]').textContent = days;
      countdown.querySelector('[data-times="h"]').textContent = hours;
      countdown.querySelector('[data-times="m"]').textContent = minutes;
      if (secondsNode) {
        secondsNode.textContent = seconds;
      }
    };

    getCountdown();
    interval = setInterval(getCountdown, 1000);
    countdown.removeAttribute('data-countdown');
  });
};
